export function parseRetryAfter(header) {
    if (!header) {
        return undefined;
    }
    const seconds = Number(header);
    if (!Number.isNaN(seconds)) {
        return new Date(Date.now() + seconds * 1000);
    }
    const date = new Date(header);
    return Number.isNaN(date.getTime()) ? undefined : date;
}
